var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightsOn25 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.282 -23)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(-70.797 23)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(-75.221 24.399) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.137,
    height: 2.273,
    transform: "translate(-78.387 27.937) rotate(-60.113)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(-79.282 31.382)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(-78.453 35.973) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(-75.314 39.558) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(-70.9 38.734)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(-67.448 38.206) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(-64.681 35.896) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(-63.548 31.485)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(-64.636 28.189) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(-67.362 25.847) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-74.845,32.027a4.555,4.555,0,0,1,4.554-4.555v4.477Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightsOn25);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lights-on-25.ff251e7a58456aa76b9bfb293b683c89.svg";